import { IAdminEventTeamsStore } from './store';

import api, { request } from '../../../api';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';
import { ITeam } from '../eventTeams/store';

export type ICreateEventTeamsAction = (
  clubId: number,
  eventId: number,
  data: any,
  force?: boolean
) => { adminEventTeams?: IAdminEventTeamsStore; errors?: IErrorsStore };

export type IDeleteEventTeamsAction = (
  clubId: number,
  eventId: number,
  teamId: number
) => { adminEventTeams?: IAdminEventTeamsStore; errors?: IErrorsStore };

export type IGetEventTeamsAction = (
  clubId: number,
  eventId: number,
  teamId: number,
  team: Partial<ITeam>
) => { adminEventTeams?: IAdminEventTeamsStore; errors?: IErrorsStore };

export type IUpdateEventTeamsAction = (
  clubId: number,
  eventId: number,
  teamId: number,
  team: Partial<ITeam>
) => { adminEventTeams?: IAdminEventTeamsStore; errors?: IErrorsStore };

export interface IAdminEventTeamsActions extends IActionGroup {
  create: ICreateEventTeamsAction;
  delete: IDeleteEventTeamsAction;
  get: IGetEventTeamsAction;
  update: IUpdateEventTeamsAction;
}

const actions = {
  create: async (state: IStore, clubId: number, eventId: number, data: number[]) => {
    const response = await request.post(api.admin.eventTeams(clubId, eventId), data);

    if (response.error) {
      return {
        errors: { adminEventTeams: { msg: response.error.statusText } }
      };
    }

    return {
      adminEventTeams: {
        ...state.adminEventTeams,
        [eventId]: [...state.adminEventTeams[eventId], response]
      }
    };
  },
  delete: async (state: IStore, clubId: number, eventId: number, teamId: number) => {
    const response = await request.delete(api.admin.eventTeam(clubId, eventId, teamId));

    if (response.error) {
      return {
        errors: { adminEventTeams: { msg: 'Error removing the Team.' } }
      };
    }

    const prevTeams = state.adminEventTeams[eventId].filter(prevTeam => prevTeam.id !== teamId);

    return {
      adminEventTeams: {
        ...state.adminEventTeams,
        [eventId]: prevTeams
      }
    };
  },
  get: async (state: IStore, clubId: number, eventId: number, force?: boolean) => {
    if (state.adminEventTeams[eventId] && state.adminEventTeams[eventId] && !force) {
      return {
        adminEventTeams: state.adminEventTeams
      };
    }

    const response = await request.get(api.admin.eventTeams(clubId, eventId));

    if (response.error) {
      return {
        errors: { adminEventTeams: { msg: 'Error retrieving the Event Teams List.' } }
      };
    }

    return {
      adminEventTeams: {
        ...state.adminEventTeams,
        [eventId]: response
      }
    };
  },
  update: async (
    state: IStore,
    clubId: number,
    eventId: number,
    teamId: number,
    team: Partial<ITeam>
  ) => {
    const response = await request.patch(api.admin.eventTeam(clubId, eventId, teamId), team);

    if (response.error) {
      return {
        errors: {
          adminEventTeams: {
            msg: 'Can`t update the team.'
          }
        }
      };
    }

    const prevTeams = state.adminEventTeams[eventId].filter(
      prevTeam => prevTeam.id !== response.id
    );

    return {
      adminEventTeams: {
        ...state.adminEventTeams,
        [eventId]: [...prevTeams, response]
      }
    };
  }
};

export default actions;
